import { RouteConfig } from "vue-router";

const regiones: RouteConfig = {
  path: "/regiones",
  name: "regiones",
  component: () => import(/* webpackChunkName: "regiones" */ "@/views/Regiones.vue"),
};

export default regiones;
